import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IMailTemplateAttachment, defaultValue } from '../../model/mail-template-attachment.model';

export const ACTION_TYPES = {
  FETCH_MAILTEMPLATEATTACHMENT_LIST: 'mailTemplateAttachment/FETCH_MAILTEMPLATEATTACHMENT_LIST',
  FETCH_MAILTEMPLATEATTACHMENT: 'mailTemplateAttachment/FETCH_MAILTEMPLATEATTACHMENT',
  CREATE_MAILTEMPLATEATTACHMENT: 'mailTemplateAttachment/CREATE_MAILTEMPLATEATTACHMENT',
  UPDATE_MAILTEMPLATEATTACHMENT: 'mailTemplateAttachment/UPDATE_MAILTEMPLATEATTACHMENT',
  DELETE_MAILTEMPLATEATTACHMENT: 'mailTemplateAttachment/DELETE_MAILTEMPLATEATTACHMENT',
  SET_BLOB: 'mailTemplateAttachment/SET_BLOB',
  RESET: 'mailTemplateAttachment/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMailTemplateAttachment>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type MailTemplateAttachmentState = Readonly<typeof initialState>;

// Reducer

export default (state: MailTemplateAttachmentState = initialState, action): MailTemplateAttachmentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MAILTEMPLATEATTACHMENT):
    case REQUEST(ACTION_TYPES.UPDATE_MAILTEMPLATEATTACHMENT):
    case REQUEST(ACTION_TYPES.DELETE_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT):
    case FAILURE(ACTION_TYPES.CREATE_MAILTEMPLATEATTACHMENT):
    case FAILURE(ACTION_TYPES.UPDATE_MAILTEMPLATEATTACHMENT):
    case FAILURE(ACTION_TYPES.DELETE_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MAILTEMPLATEATTACHMENT):
    case SUCCESS(ACTION_TYPES.UPDATE_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MAILTEMPLATEATTACHMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/mail-template-attachments';

// Actions

export const getEntities: ICrudGetAllAction<IMailTemplateAttachment> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT_LIST,
    payload: axios.get<IMailTemplateAttachment>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IMailTemplateAttachment> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MAILTEMPLATEATTACHMENT,
    payload: axios.get<IMailTemplateAttachment>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IMailTemplateAttachment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MAILTEMPLATEATTACHMENT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IMailTemplateAttachment> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MAILTEMPLATEATTACHMENT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IMailTemplateAttachment> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MAILTEMPLATEATTACHMENT,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
